import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import { LogErrors } from './../../utilities/LogErrors'
//import { useLanguage } from './../../utilities/LanguageContext'

import { Loading } from './../Commons/Loading'
import { SignUpHeader } from './../Commons/Header/SignUpHeader'
import { GoToTop } from './../Commons/GoToTop'
import { GoToBack } from './../Commons/GoToBack'

import { DeleteSessionInfo, DeleteSignUpInfo, GetSignUpInfo } from './../../utilities/BL/Sessions'
import { CalculateAge, FormatDate } from './../../utilities/BL/RegisteredApplicants'

// Nayarit:
import { Pedagogica181 } from './SpecialMessage/Pedagogica181'
import { BenitesSilva } from './SpecialMessage/BenitesSilva'

// Durango:
import { ProfesorCarlosACarrillo } from './SpecialMessage/ProfesorCarlosACarrillo'
import { ProfesorAntonioEstopier } from './SpecialMessage/ProfesorAntonioEstopier'

// Baja California Sur:
import { Layout1 } from './SpecialMessage/BCS/Layout1'
import { Layout2 } from './SpecialMessage/BCS/Layout2'
import { Layout3 } from './SpecialMessage/BCS/Layout3'
import { Layout4 } from './SpecialMessage/BCS/Layout4'

// General:
import { General } from './SpecialMessage/General'

import { SetMexicoTheme } from './../../utilities/BL/Settings'


const RegisteredApplicant = () => {
    //const { translate } = useLanguage() // Obtén la función de traducción desde el contexto
    const navigate = useNavigate()

    const [applicant, setApplicant] = useState({})
    const [isLoading, setIsLoading] = useState(true) // Estado quede carga
    const [exitConfirmMessage, setExitConfirmMessage] = useState(false)
    const [theme, setTheme] = useState(1)

    const [age, setAge] = useState(null)
    const [birthdateFormatted, setBirthdateFormatted] = useState(null)
    const [specialMessage, setSpecialMessage] = useState(null)
    const [stateSpecialMessage, setStateSpecialMessage] = useState(null)

    const [urlToReturn, setUrlToReturn] = useState(null)

    const normalSchools = {
        nayarit: {
            id: 1,
            schools: {
                BenitesSilva: 4,
                Pedagogica181: 5
            }
        },
        durango: {
            id: 2,
            schools: {
                ProfesorCarlosACarrillo: 8,
                ProfesorAntonioEstopier: 9
            }
        },
        baja_california_sur: {
            id: 3, // Creado fijo
            schools: {
                BenemeritaEscuelaNormalUrbanaProfDomingoCarballoFelix: 10,
                CentroRegionalDeEducacionNormalMarceloRubioRuiz: 11,
                EscuelaNormalSuperiorDelEdoBCSProfEnriqueEstradaLuceroSedeLaPaz: 12,
                EscuelaNormalSuperiorDelEdoBCSProfEnriqueEstradaLuceroExtCdConstitucion: 13,
                EscuelaNormalSuperiorDelEdoBCSProfEnriqueEstradaLuceroExtSanJoseDelCabo: 14,
                EscuelaNormalSuperiorDeCulturaFisicaProfRomanPozoMendezDelEdoBCS: 15
            }
        }
    }


    const PrintData = async () => {
        try {
            // window.alert('Información impresa')
            // document.body.classList.remove('SmallFont')
            // document.body.classList.remove('BigFont')
            // document.body.classList.remove('DarkTheme')
            //await setTheme(1)
            setTheme(1)
            window.print()
        } catch (error) {
            await LogErrors('PrintData - RegisteredApplicant', error)
        }
    }

    const ShowExitConfirmMessage = async () => {
        try {
            setExitConfirmMessage(true)
        } catch (error) {
            await LogErrors('ShowExitConfirmMessage - RegisteredApplicant', error)
        }
    }

    const HideExitConfirmMessage = async () => {
        try {
            setExitConfirmMessage(false)
        } catch (error) {
            await LogErrors('HideExitConfirmMessage - RegisteredApplicant', error)
        }
    }

    const DeleteSignUpData = async () => {
        try {
            await DeleteSignUpInfo()
            
            if (urlToReturn) {
                navigate(urlToReturn)
            } else {
                navigate('/')
            }
        } catch (error) {
            await LogErrors('DeleteSignUpData - RegisteredApplicant', error)
        }
    }

    const LoadPage = async () => {
        try {
            // Establecer el tema a la web
            await SetMexicoTheme()


            const response = await GetSignUpInfo()
            
            if (response.success) {
                setApplicant(response.data)

                const tmpAge = await CalculateAge(response.data.birthdate)
                if (tmpAge.success) {
                    setAge(tmpAge.data)
                }

                const tmpDate = await FormatDate(response.data.birthdate)
                if (tmpDate.success) {
                    setBirthdateFormatted(tmpDate.data)
                }
                
                switch (response.data.normalSchoolId) {
                    case normalSchools.nayarit.schools.BenitesSilva:
                        setSpecialMessage(normalSchools.nayarit.schools.BenitesSilva)
                        setStateSpecialMessage(normalSchools.nayarit.id)
                        break

                    case normalSchools.nayarit.schools.Pedagogica181:
                        setSpecialMessage(normalSchools.nayarit.schools.Pedagogica181)
                        setStateSpecialMessage(normalSchools.nayarit.id)
                        break

                    case normalSchools.durango.schools.ProfesorCarlosACarrillo:
                        setSpecialMessage(normalSchools.durango.schools.ProfesorCarlosACarrillo)
                        setStateSpecialMessage(normalSchools.durango.id)
                        break
                        
                    case normalSchools.durango.schools.ProfesorAntonioEstopier:
                        setSpecialMessage(normalSchools.durango.schools.ProfesorAntonioEstopier)
                        setStateSpecialMessage(normalSchools.durango.id)
                        break

                    case normalSchools.baja_california_sur.schools.BenemeritaEscuelaNormalUrbanaProfDomingoCarballoFelix:
                        setSpecialMessage(normalSchools.baja_california_sur.schools.BenemeritaEscuelaNormalUrbanaProfDomingoCarballoFelix)
                        setStateSpecialMessage(normalSchools.baja_california_sur.id)
                        break

                    case normalSchools.baja_california_sur.schools.CentroRegionalDeEducacionNormalMarceloRubioRuiz:
                        setSpecialMessage(normalSchools.baja_california_sur.schools.CentroRegionalDeEducacionNormalMarceloRubioRuiz)
                        setStateSpecialMessage(normalSchools.baja_california_sur.id)
                        break

                    case normalSchools.baja_california_sur.schools.EscuelaNormalSuperiorDelEdoBCSProfEnriqueEstradaLuceroSedeLaPaz:
                        setSpecialMessage(normalSchools.baja_california_sur.schools.EscuelaNormalSuperiorDelEdoBCSProfEnriqueEstradaLuceroSedeLaPaz)
                        setStateSpecialMessage(normalSchools.baja_california_sur.id)
                        break

                    case normalSchools.baja_california_sur.schools.EscuelaNormalSuperiorDelEdoBCSProfEnriqueEstradaLuceroExtCdConstitucion:
                        setSpecialMessage(normalSchools.baja_california_sur.schools.EscuelaNormalSuperiorDelEdoBCSProfEnriqueEstradaLuceroExtCdConstitucion)
                        setStateSpecialMessage(normalSchools.baja_california_sur.id)
                        break

                    case normalSchools.baja_california_sur.schools.EscuelaNormalSuperiorDelEdoBCSProfEnriqueEstradaLuceroExtSanJoseDelCabo:
                        setSpecialMessage(normalSchools.baja_california_sur.schools.EscuelaNormalSuperiorDelEdoBCSProfEnriqueEstradaLuceroExtSanJoseDelCabo)
                        setStateSpecialMessage(normalSchools.baja_california_sur.id)
                        break

                    case normalSchools.baja_california_sur.schools.EscuelaNormalSuperiorDeCulturaFisicaProfRomanPozoMendezDelEdoBCS:
                        setSpecialMessage(normalSchools.baja_california_sur.schools.EscuelaNormalSuperiorDeCulturaFisicaProfRomanPozoMendezDelEdoBCS)
                        setStateSpecialMessage(normalSchools.baja_california_sur.id)
                        break

                    default:
                        setSpecialMessage(null)
                        break
                }

                
                const tmpUrlToReturn = response?.data?.urlToReturn
                
                if (tmpUrlToReturn) {
                    if (tmpUrlToReturn === '') {
                        await DeleteSessionInfo()
                        setUrlToReturn('/')
                    } else {
                        setUrlToReturn(tmpUrlToReturn)
                    }
                } else {
                    await DeleteSessionInfo()
                }
            } else {
                //Mostrar mensaje de error
                console.log(response.message)
                //navigate('/')
            }
        } catch (error) {
            await LogErrors('LoadPage - RegisteredApplicant', error)
        } finally {
            setIsLoading(false)
        }
    }

    //--- Eventos de la página web ---//
    useEffect(() => {
        LoadPage()
    },[]) // El array vacío [] asegura que useEffect se ejecute solo una vez, al montar
    //--- Eventos de la página web ---//

    // Detectar la tecla ESC para cerrar el modal
    useEffect(() => {
        const handleEscapeKey = (event) => {
            if (event.key === 'Escape') {
                HideExitConfirmMessage()
            }
        }
    
        window.addEventListener('keydown', handleEscapeKey)
    
        return () => {
            window.removeEventListener('keydown', handleEscapeKey)
        }
    }, [])

    useEffect(() => {
        const handlePrintShortcut = (event) => {
            const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0
            const isCtrlPressed = isMac ? event.metaKey : event.ctrlKey

            if (isCtrlPressed && event.key.toLowerCase() === 'p') {
                event.preventDefault() // Prevenir el diálogo de impresión del navegador
                PrintData()
            }
        }

        window.addEventListener('keydown', handlePrintShortcut)

        return () => {
            window.removeEventListener('keydown', handlePrintShortcut)
        }
    }, [])


    return (
        isLoading ? (
            <Loading />
        ) : (
            <>
                <SignUpHeader setTheme={setTheme} />
                
                {/* <div className='RegisteredApplicant__Header'>
                    <img src='/img/registeredApplicants/degesum-logotipo.png' className='RegisteredApplicant__Header__Images' />
                    <img src='/img/registeredApplicants/upn-logotipo.png' className='RegisteredApplicant__Header__Images RegisteredApplicant__Header__Images--UPN' />
                </div> */}

                {urlToReturn && (
                    <div className='container RegisteredApplicant__ReturnButton'>
                        <GoToBack url={urlToReturn} />
                    </div>
                )}

                <main className='RegisteredApplicant container'>
                    <div className='RegisteredApplicant__HeaderImages'>
                        <img src='/img/registeredApplicants/degesum-logotipo.png' className='RegisteredApplicant__HeaderImages__Images' />
                        <img src='/img/registeredApplicants/upn-logotipo.png' className='RegisteredApplicant__HeaderImages__Images RegisteredApplicant__HeaderImages__Images--UPN' />
                    </div>

                    {specialMessage === normalSchools.durango.schools.ProfesorAntonioEstopier ? (
                        <p className='mt-4 text-center'>FICHA DE REGISTRO DEL EXAMEN DE ADMISIÓN ESCUELAS NORMALES</p>
                    ) : stateSpecialMessage === normalSchools.baja_california_sur.id ? (
                        <p className='mt-4 text-center'>COMPROBANTE DE REGISTRO EXAMEN DE ADMISIÓN ESCUELAS NORMALES "RIACTIVOS"</p>
                    ) : (
                        <p className='mt-4 text-center'>FICHA PARA EL PAGO DEL EXAMEN DE ADMISIÓN ESCUELAS NORMALES</p>
                    )}

                    <div className='RegisteredApplicant__Info'>
                        <p className='RegisteredApplicant__Info__Text--Highlight'>DATOS DEL ASPIRANTE:</p>
                        <p>CURP: <span className='RegisteredApplicant__Info__Text--Underline'>{applicant.curp}</span></p>
                        <p>Nombre: <span className='RegisteredApplicant__Info__Text--Underline'>{applicant.name} {applicant.paternalSurname} {applicant.maternalSurname}</span></p>
                        <p>Fecha de nacimiento: <span className='RegisteredApplicant__Info__Text--Underline'>{birthdateFormatted}</span></p>
                        <p>Edad: <span className='RegisteredApplicant__Info__Text--Underline'>{age}</span></p>

                        <p className='RegisteredApplicant__Info__Text--Highlight'>ESCUELA DE PROCEDENCIA:</p>
                        <p>Nombre de la escuela: <span className='RegisteredApplicant__Info__Text--Underline'>{applicant.nameOfHomeSchool}</span></p>
                        <p>Estado: <span className='RegisteredApplicant__Info__Text--Underline'>{applicant.nameState}</span></p>
                        <p>Sector: <span className='RegisteredApplicant__Info__Text--Underline'>{applicant.nameSector}</span></p>
                        <p>Promedio: <span className='RegisteredApplicant__Info__Text--Underline'>{applicant.average}</span></p>
                        
                        <p className='RegisteredApplicant__Info__Text--Highlight'>ESCUELA NORMAL A LA QUE DESEA INSCRIBIRSE:</p>
                        <p>Nombre de la escuela normal: <span className='RegisteredApplicant__Info__Text--Underline'>{applicant.nameNormalSchool}</span></p>
                        <p>Estado: <span className='RegisteredApplicant__Info__Text--Underline'>{applicant.nameNormalState}</span></p>
                        <p>Especialidad: <span className='RegisteredApplicant__Info__Text--Underline'>{applicant.nameMajor}</span></p>

                        <p className='RegisteredApplicant__Info__Text--Highlight RegisteredApplicant__Info__Text--Center'>CÓDIGO DE ACCESO A RIACTIVOS:</p>
                        <p className='RegisteredApplicant__Info__Text--Code RegisteredApplicant__Info__Text--Center'>{applicant.accessCode}</p>
                    </div>

                    {specialMessage === normalSchools.nayarit.schools.Pedagogica181 && (
                        <Pedagogica181 applicant={applicant} />
                    )}

                    {specialMessage === normalSchools.nayarit.schools.BenitesSilva && (
                        <BenitesSilva applicant={applicant} />
                    )}

                    {specialMessage === normalSchools.durango.schools.ProfesorCarlosACarrillo && (
                        <ProfesorCarlosACarrillo applicant={applicant} />
                    )}

                    {specialMessage === normalSchools.durango.schools.ProfesorAntonioEstopier && (
                        <ProfesorAntonioEstopier applicant={applicant} />
                    )}

                    {(specialMessage === normalSchools.baja_california_sur.schools.EscuelaNormalSuperiorDelEdoBCSProfEnriqueEstradaLuceroSedeLaPaz ||
                    specialMessage === normalSchools.baja_california_sur.schools.EscuelaNormalSuperiorDelEdoBCSProfEnriqueEstradaLuceroExtCdConstitucion ||
                    specialMessage === normalSchools.baja_california_sur.schools.EscuelaNormalSuperiorDelEdoBCSProfEnriqueEstradaLuceroExtSanJoseDelCabo) && (
                        <Layout1 applicant={applicant} />
                    )}

                    {(specialMessage === normalSchools.baja_california_sur.schools.BenemeritaEscuelaNormalUrbanaProfDomingoCarballoFelix) && (
                        <Layout2 applicant={applicant} />
                    )}

                    {(specialMessage === normalSchools.baja_california_sur.schools.EscuelaNormalSuperiorDeCulturaFisicaProfRomanPozoMendezDelEdoBCS) && (
                        <Layout3 applicant={applicant} />
                    )}

                    {(specialMessage === normalSchools.baja_california_sur.schools.CentroRegionalDeEducacionNormalMarceloRubioRuiz) && (
                        <Layout4 applicant={applicant} />
                    )}

                    {specialMessage === null && (
                        <General applicant={applicant} />
                    )}
                </main>

                <div className='RegisteredApplicant__FooterImages'>
                    {theme && theme === 2 ? (
                        <img src='/img/registeredApplicants/riactivos-logotipo-blanco.png' className='RegisteredApplicant__FooterImages__Images' />
                    ) : (
                        <img src='/img/registeredApplicants/riactivos-logotipo.png' className='RegisteredApplicant__FooterImages__Images' />
                    )}
                    {theme && theme === 2 ? (
                        <img src='/img/registeredApplicants/five-digital-minds-logotipo-blanco.png' className='RegisteredApplicant__FooterImages__Images' />
                    ) : (
                        <img src='/img/registeredApplicants/five-digital-minds-logotipo.png' className='RegisteredApplicant__FooterImages__Images' />
                    )}
                    <img src='/img/registeredApplicants/edutest-logotipo.png' className='RegisteredApplicant__FooterImages__Images' />
                </div>

                <aside className='RegisteredApplicant__BottomMenu'>
                    <div className='RegisteredApplicant__BottomMenu__ContainerButtons'>
                        <button type='button' className='RegisteredApplicant__BottomMenu__ContainerButtons__Buttons--Success' onClick={PrintData}><i className="bi bi-printer"></i> Imprimir tu comprobante de registro</button>
                        {urlToReturn ? (
                            <button type='button' className='RegisteredApplicant__BottomMenu__ContainerButtons__Buttons--Danger' onClick={DeleteSignUpData}><i className="bi bi-box-arrow-left"></i> Regresar</button>
                        ) : (
                            <button type='button' className='RegisteredApplicant__BottomMenu__ContainerButtons__Buttons--Danger' onClick={ShowExitConfirmMessage}><i className="bi bi-box-arrow-left"></i> Salir</button>
                        )}
                    </div>
                </aside>

                {exitConfirmMessage && (
                    <>  
                        <div className='BackgroundModal' onClick={HideExitConfirmMessage}></div>
                        <div className='Modal'>
                            <button type='button' className='Modal__Button' onClick={HideExitConfirmMessage}>X</button>
                            
                            <p className='Modal__Title Modal__Title--Highlight'>¿Estás seguro que deseas salir de esta página?</p>
                            <p><span className='Modal__Text--Highlight'>Recuerda guardar o imprimir tu comprobante de registro</span> del examen de admisión antes de salir.</p>
                            
                            <div className='Modal__Container__Buttons'>
                                <button type='button' className='Modal__Container__Buttons--Success' onClick={DeleteSignUpData}>Sí, salir ahora</button>
                                <button type='button' className='Modal__Container__Buttons--Danger' onClick={HideExitConfirmMessage}>No quiero salir</button>
                            </div>
                        </div>
                    </>
                )}

                <GoToTop />
            </>
        )
    )
}

export { RegisteredApplicant };